import React from "react";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { FaPencil, FaRegFile } from "react-icons/fa6";
import ViewEditor from "../../components/common/ViewEditor";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw } from "draft-js";
import CheckBox from "../../components/common/form/CheckBox";
import CheckBoxInline from "../../components/common/form/CheckBoxInline";
import { resolveFileName, getFileExtension, getFileIconClass } from "./fileUtils.js";

class SubQuestionRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subToolbarVisible: {},
    };
  }

  toggleSubToolbar = (qid) => {
    this.setState((prev) => ({
      subToolbarVisible: {
        ...prev.subToolbarVisible,
        [qid]: !prev.subToolbarVisible[qid],
      },
    }));
  };

  renderPassage = (question, getQuestionPassageContent) => {
    if (question?.is_passage && question?.passage_id && question?.passage_content) {
      return (
        <div className="mb-5 mt-5">
          <ViewEditor
            editorState={getQuestionPassageContent(question.passage_content)}
          />
        </div>
      );
    }
    return null;
  };

  parseEditorState = (content) => {
    try {
      const parsed = JSON.parse(content);
      return parsed?.length
        ? EditorState.createWithContent(convertFromRaw(parsed[0]))
        : EditorState.createEmpty();
    } catch {
      return EditorState.createEmpty();
    }
  };

  render() {
    const {
      mainQuestion,
      index,
      qIndex,
      subQuestions,
      makeRevise,
      makeSubQuestionEdit,
      getQuestionPassageContent,
      sections = [],
      submissionAnswerMode = {},
      onsubmissionAnswerModeChange,
      getSubmissionContent,
      deleteSubmissionContent,
      answers = {},
      onDownloadAttachment,
      candidateId,
      containerName,
      handleAttachFileClick,
      handleFileChange,
      handleFileDownload,
      handleFileDelete,
    } = this.props;

    const subQuestionIds = mainQuestion?.sub_questions
      ? mainQuestion.sub_questions.split(",").map((id) => id.trim()).filter(Boolean)
      : [];

    const mainQuestionEditor = this.parseEditorState(mainQuestion?.content);
    const employeeType = sessionStorage.getItem("employeeType");
    const userType = sessionStorage.getItem("userType");
    const isDeopOrMasad = employeeType === "DEOP" || employeeType === "MASAD" || userType === "DEOP" || userType === "MASAD";

    return (
      <div className="col-md-12" style={{ overflow: "auto" }}>

        {/* -------- Main Question -------- */}
        {this.renderPassage(mainQuestion, getQuestionPassageContent)}

        {/* Main Question with Mark for Review on the right */}
        {/* match margins/paddings used in MCQ layout: mb-2 mt-4 pl-4 pr-4 */}
        <div className="d-flex mb-2 mt-4 pl-4 pr-4 overflow-hidden all-questions-title">
          <div className="d-flex align-items-start" style={{ flex: 1 }}>
            <div
              className="number-wrap"
              style={{ fontSize: 12, fontWeight: 600, marginTop: 3, marginRight: 8 }}
            >
              {index + 1}.
            </div>
            <div className="rdw-editor-question" style={{ flex: 1 }}>
              <ViewEditor editorState={mainQuestionEditor} />
            </div>
          </div>
          {!isDeopOrMasad && (
            <div className="pl-1 pr-1 rounded d-inline-block push-button" style={{ fontSize: "11px", border: "none" }}>
              <CheckBoxInline>
                <CheckBox
                  key={qIndex}
                  onClick={(e) => makeRevise(e, qIndex)}
                  checked={mainQuestion.needToRevise || false}
                  checkBoxName="Mark for Review"
                  style={{ color: "#5458AF", transform: "scale(0.85)" }}
                  inputStyle={{ outline: "none" }}
                />
              </CheckBoxInline>
            </div>
          )}
        </div>

        {/* -------- Sub Questions -------- */}
        {subQuestionIds.map((qidStr, j) => {
          const qid = parseInt(qidStr);
          const sub = subQuestions[qid];
          if (!sub) return null;

          const subEditor = this.parseEditorState(sub.content);
          const mode = submissionAnswerMode[sub.question_id] || "TYPE";

          const renderSubDescriptive = () => {
            const attachedFiles = Array.isArray(answers?.[sub.question_id])
              ? answers[sub.question_id]
              : [];

            return (
              <div className="RichEditor-root-descriptive-answer mt-3 mb-4">

                <div className="d-flex mb-3" style={{ gap: "8px" }}>
                  <input
                    type="file"
                    id={`subFileInput-${sub.question_id}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e, sub.question_id)}
                  />

                  <button
                    type="button"
                    className="btn btn-sm exam-action-btn"
                    onClick={() => handleAttachFileClick(`subFileInput-${sub.question_id}`)}
                  >
                    <IoDocumentAttachOutline
                      style={{ fontSize: 13, marginRight: 4 }}
                    />
                    Attach files
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm exam-action-btn"
                    onClick={() =>
                      this.toggleSubToolbar(sub.question_id)
                    }
                  >
                    <FaPencil style={{ fontSize: 11, marginRight: 4 }} />
                    {this.state.subToolbarVisible[sub.question_id] ? "Disable toolbar" : "Enable toolbar"}
                  </button>
                </div>

                {/* uploaded files above sub-editor */}
                {attachedFiles.length > 0 && (
                  <div className="mb-2">
                    {attachedFiles.map((file, idx) => {
                      const fileName = resolveFileName(file);
                      const fileExt = getFileExtension(fileName);
                      const iconClass = getFileIconClass(fileName);
                      return (
                        <div
                          key={idx}
                          className="uploaded-file-card d-flex align-items-center mb-2"
                        >
                          <div className={`file-icon ${iconClass}`}>
                            <FaRegFile />
                          </div>
                          <div className="file-meta flex-grow-1 ms-3">
                            <a
                              href="#!"
                              onClick={(e) => handleFileDownload(e, sub.question_id, file)}
                              className="file-title"
                            >
                              {fileName || "Untitled file"}
                            </a>
                            <span className="file-subtitle">Uploaded</span>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-icon delete-file-btn ms-2"
                            onClick={() => handleFileDelete(file, sub.question_id)}
                            title="Delete attachment"
                          >
                            ×
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className="editor-wrapper" style={{ position: "relative" }}>
                  <Editor
                    placeholder="Type your answer here..."
                    editorStyle={{
                      maxHeight: "120px",
                      overflow: "auto",
                      backgroundColor: "#fafafa",
                      padding: "12px",
                      border: "none",
                      borderRadius: "0"
                    }}
                    editorState={sub.answer || EditorState.createEmpty()}
                    onEditorStateChange={(e) =>
                      makeSubQuestionEdit(
                        e,
                        sub.question_id,
                        mainQuestion.question_id
                      )
                    }
                    toolbar={
                      this.state.subToolbarVisible[sub.question_id]
                        ? {
                          fontFamily: {
                            options: [
                              "Arial",
                              "Georgia",
                              "Impact",
                              "Tahoma",
                              "Times New Roman",
                              "Verdana",
                              "Kushpoo",
                              "Baamini",
                              "FMAbhaya",
                            ],
                          },
                        }
                        : {}
                    }
                    toolbarClassName={
                      this.state.subToolbarVisible[sub.question_id]
                        ? "vertical-toolbar"
                        : "hide-toolbar"
                    }
                  />
                </div>
              </div>
            );
          };

          return (
            <div
              className="col-md-12 ml-5 pl-5"
              key={`sub-${sub.question_id}`}
            >
              {this.renderPassage(sub, getQuestionPassageContent)}

              <div className="row d-flex align-items-center">
                <div
                  className="col-md-1 col-1 number-wrap"
                  style={{ fontSize: 12 }}
                >
                  {j + 1}.
                </div>

                {sections.length > 0 && sub.is_optional && (
                  <span className="badge badge-primary mr-2">
                    Optional
                  </span>
                )}

                <div className="col-md-11 col-11">
                  <div className="row">
                    <div className="col-md-11 col-11 rdw-editor-question overflow-hidden all-questions-title">
                      <ViewEditor editorState={subEditor} />
                    </div>
                  </div>

                  {renderSubDescriptive()}
                </div>
              </div>

              <div className="separator separator-dashed separator-border-2 mt-5 mb-5" />
            </div>
          );
        })}
      </div>
    );
  }
}

export default SubQuestionRenderer;
